import { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/react-hooks';

import GET_MERCHANT_OFFERS_RESULTS from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffers.queries';
import {
  Offer,
  TargetingRuleType,
} from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffer.types';

import {
  defaultOptions,
  dropdownOptions,
} from 'components/FormSelect/FormSelect.helpers';

type QueryResponse = {
  offerFindBy: {
    offers: Offer[];
  };
};

const offersByUuid: Map<string, Offer> = new Map();

export const useMerchantOffers = (
  merchantUuid: string,
  targetingRuleType: TargetingRuleType,
) => {
  const initialMerchantOffers = dropdownOptions(
    'Merchant Offers',
    'Select Offer...',
  );
  const [merchantOffers, setMerchantOffers] = useState(initialMerchantOffers);

  useEffect(() => {
    setMerchantOffers(initialMerchantOffers);
  }, [merchantUuid]);

  const filterBySegmentType = (offer: Offer) =>
    offer.segments.some((segment) =>
      segment.targetingRules.some(
        (targetingRule) => targetingRule.type === targetingRuleType,
      ),
    );

  const handleMechantOffersResponse = ({
    offerFindBy: { offers },
  }: QueryResponse) => {
    const merchantOffersCopy = initialMerchantOffers;
    merchantOffers.options = [defaultOptions];
    offers.filter(filterBySegmentType).forEach((offer) => {
      merchantOffersCopy.options.push({
        key: offer.offerUuid,
        value: offer.offerUuid,
        text: offer.offerName,
        description: offer.offerDescription.slice(0, 18),
      });
    });
    offers.map((offer) => {
      offersByUuid.set(offer.offerUuid, offer);
    });
    setMerchantOffers(merchantOffersCopy);
  };

  const [
    getOfferByUuid,
    { loading: mechantOffersLoading },
  ] = useLazyQuery<QueryResponse>(GET_MERCHANT_OFFERS_RESULTS, {
    variables: {
      params: merchantUuid,
    },
    onCompleted: handleMechantOffersResponse,
  });

  return {
    merchantOffers,
    offersByUuid,
    mechantOffersLoading,
    getOfferByUuid,
  };
};
